import { useState } from "react";
import ResetSvgComponent from "../../../assets/svg-components/reset";
import InputField from "@_common/InputRuleFeild";

export default function LegalUpdateFilterForm(props: any) {
  const {
    handleChangeSelect,
    countryList,
    states,
    industryList,
    selectedIndustryListIds,
    handleChangeSelectMulti,
    regulationList,
    selectedRegulationListIds,
    handleChangeRegulationMulti,
    ministryList,
    selectedMinistryListIds,
    handleChangeMinistryMulti,
    departmentList,
    selectedDepartmentListIds,
    handleChangeDepartmentMulti,
    notificationTypeList,
    selectedNotificationTypeListIds,
    handleChangeNotificationTypeMulti,
    statesList,
    handleChangeStateMulti,
    selectedStatesListIds,
    tagsList,
    handleChangeTagsMulti,
    selectedTagsListIds,
  } = props;
  return (
    <div
      className={`filter-slidder-wrapper  ${
        props.filterIsOpen ? "filter-slidder-wrapper--active" : ""
      }`}
    >
      <div className="filter-form-wrappper w-100 active border_bottom">
        <div className="filter-form-wrappper__container">
          <div className="filter-header-wrapper d-flex align-items-center justify-content-between">
            <div className="filter-header-left-wrapper d-flex align-items-center">
              <div className="filter-close-wrapper">
                <img
                  src="/images/close-circle.svg"
                  className="img-fluid cursor-pointer"
                  onClick={props.handleFilter}
                />
              </div>
              <div className="filter-title-wrapper">
                <h6 className="filter-form-wrappper__title">Filter</h6>
              </div>

              <div className="filter-module-details-wrapper">
                <div className="filter-module-name">{props.moduleName}</div>
                <div className="filter-submodule-name">
                  {props.subModuleName}
                </div>
              </div>
            </div>

            <div className="filter-header-right-wrapper">
              <div className="filter-form-wrappper__cta-wrapper p-0 d-flex">
                <button
                  className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--reset"
                  onClick={props.reset}
                >
                  <div className="d-flex align-items-center mt--3">
                    <ResetSvgComponent size={24} color={"#5F6368"} /> Reset
                  </div>
                </button>

                <button
                  className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--cancel"
                  onClick={props.handleFilter}
                >
                  Cancel
                </button>

                <button
                  className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--search"
                  onClick={props.handleSubmitSmartFilter}
                >
                  Search
                </button>
              </div>
            </div>
          </div>

          <div className="filter-body-wrapper">
            <div className="filter-body-card">
              <div className="filter-card-title">Filter By</div>
              <div className="d-flex justify-content-between flex-column">
                <div className="filter-form-wrappper__location">
                  <div className=" w-100 filter-field-main-wrap">
                    <div className="filter-form-wrappper__container border-0">
                      <div className="d-flex w-100 filter-field-main-wrap">
                        {/* <div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap">
                          <label
                            htmlFor="country"
                            className="filter-form-wrappper__label filter-fields-label"
                          >
                            Country
                          </label>
                          <div className="filter-form-wrappper__location-input select-dd-new">
                            <InputField
                              inputType="INPUT_REACT_SELECT"
                              placeholder="Choose Country"
                              className="form-control w-100"
                              name="country_id"
                              id="country_id"
                              options={countryList}
                              value={props.country_ID}
                              onChange={(e: any) =>
                                handleChangeSelect(e, "country_id")
                              }
                              label="Country"
                            />
                          </div>
                        </div> */}
                        <div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap">
                          <label
                            htmlFor="state"
                            className="filter-form-wrappper__label filter-fields-label"
                          >
                            State
                          </label>
                          <div className="filter-form-wrappper__location-input select-dd-new">
                            <InputField
                              inputType="INPUT_REACT_SELECT"
                              placeholder="Choose State"
                              className="form-control w-100"
                              name="state_id"
                              id="state_id"
                              label="Last Name"
                              options={statesList}
                              // options={states}
                              value={selectedStatesListIds}
                              // value={props.state_ID}
                              onChange={(e: any) =>
                                handleChangeStateMulti(e)
                              }
                              // onChange={(e: any) =>
                              //   handleChangeSelect(e, "state_id")
                              // }
                              // isClear
                              isMulti
                            />
                          </div>
                        </div>

                        <div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap">
                          <label
                            htmlFor="state"
                            className="filter-form-wrappper__label filter-fields-label"
                          >
                            Tags
                          </label>
                          <div className="filter-form-wrappper__location-input select-dd-new">
                            <InputField
                              inputType="INPUT_REACT_SELECT"
                              placeholder="Choose State"
                              className="form-control w-100"
                              name="state_id"
                              id="state_id"
                              label="Last Name"
                              options={tagsList}
                              // options={states}
                              value={selectedTagsListIds}
                              // value={props.state_ID}
                              onChange={(e: any) =>
                                handleChangeTagsMulti(e)
                              }
                              // onChange={(e: any) =>
                              //   handleChangeSelect(e, "state_id")
                              // }
                              // isClear
                              isMulti
                            />
                          </div>
                        </div>
                      </div>

                      <div className="d-flex w-100 filter-field-main-wrap">
                        <div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap">
                          <label
                            htmlFor="rule"
                            className="filter-form-wrappper__label filter-fields-label"
                          >
                            Industry
                          </label>
                          <div className="filter-form-wrappper__location-input">
                            <InputField
                              inputType="INPUT_REACT_SELECT"
                              placeholder="Choose Industry"
                              className="form-control"
                              name="legislation_rule_id"
                              id="legislation_rule_id"
                              label="Legislation Rule ID"
                              options={industryList}
                              value={selectedIndustryListIds}
                              onChange={(e: any) => handleChangeSelectMulti(e)}
                              isMulti
                            />
                          </div>
                        </div>

                        <div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap">
                          <label
                            htmlFor="rule"
                            className="filter-form-wrappper__label filter-fields-label"
                          >
                            Regulation
                          </label>
                          <div className="filter-form-wrappper__location-input">
                            <InputField
                              inputType="INPUT_REACT_SELECT"
                              placeholder="Choose Industry"
                              className="form-control"
                              name="legislation_rule_id"
                              id="legislation_rule_id"
                              label="Legislation Rule ID"
                              options={regulationList}
                              value={selectedRegulationListIds}
                              onChange={(e: any) =>
                                handleChangeRegulationMulti(e)
                              }
                              isMulti
                            />
                          </div>
                        </div>
                      </div>

                      <div className="d-flex w-100 filter-field-main-wrap">
                        <div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap">
                          <label
                            htmlFor="rule"
                            className="filter-form-wrappper__label filter-fields-label"
                          >
                            Ministry
                          </label>
                          <div className="filter-form-wrappper__location-input">
                            <InputField
                              inputType="INPUT_REACT_SELECT"
                              placeholder="Choose Industry"
                              className="form-control"
                              name="legislation_rule_id"
                              id="legislation_rule_id"
                              label="Legislation Rule ID"
                              options={ministryList}
                              value={selectedMinistryListIds}
                              onChange={(e: any) =>
                                handleChangeMinistryMulti(e)
                              }
                              isMulti
                            />
                          </div>
                        </div>

                        <div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap">
                          <label
                            htmlFor="rule"
                            className="filter-form-wrappper__label filter-fields-label"
                          >
                            Department
                          </label>
                          <div className="filter-form-wrappper__location-input">
                            <InputField
                              inputType="INPUT_REACT_SELECT"
                              placeholder="Choose Industry"
                              className="form-control"
                              name="legislation_rule_id"
                              id="legislation_rule_id"
                              label="Legislation Rule ID"
                              options={departmentList}
                              value={selectedDepartmentListIds}
                              onChange={(e: any) =>
                                handleChangeDepartmentMulti(e)
                              }
                              isMulti
                            />
                          </div>
                        </div>
                      </div>

                      <div className="d-flex w-100 filter-field-main-wrap">
                        <div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap">
                          <label
                            htmlFor="rule"
                            className="filter-form-wrappper__label filter-fields-label"
                          >
                            Notification Type
                          </label>
                          <div className="filter-form-wrappper__location-input">
                            <InputField
                              inputType="INPUT_REACT_SELECT"
                              placeholder="Choose Industry"
                              className="form-control"
                              name="legislation_rule_id"
                              id="legislation_rule_id"
                              label="Legislation Rule ID"
                              options={notificationTypeList}
                              value={selectedNotificationTypeListIds}
                              onChange={(e: any) =>
                                handleChangeNotificationTypeMulti(e)
                              }
                              isMulti
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
